// src/enums/countries.ts
// Static reference data for country/city dropdowns used across the admin app
// (branch/show room addresses, company profile address, car country of
// origin). Cities are the capital plus a handful of other major cities —
// not exhaustive, just enough to cover common data-entry needs.
export interface Country {
  code: string;
  name: string;
  cities: string[];
}

export const countries: Country[] = [
  { code: 'AF', name: 'Afghanistan', cities: ['Kabul', 'Kandahar', 'Herat', 'Mazar-i-Sharif'] },
  { code: 'AL', name: 'Albania', cities: ['Tirana', 'Durrës', 'Vlorë', 'Shkodër'] },
  { code: 'DZ', name: 'Algeria', cities: ['Algiers', 'Oran', 'Constantine', 'Annaba'] },
  { code: 'AD', name: 'Andorra', cities: ['Andorra la Vella'] },
  { code: 'AO', name: 'Angola', cities: ['Luanda', 'Huambo', 'Lobito', 'Benguela'] },
  { code: 'AR', name: 'Argentina', cities: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata'] },
  { code: 'AM', name: 'Armenia', cities: ['Yerevan', 'Gyumri', 'Vanadzor'] },
  { code: 'AU', name: 'Australia', cities: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Canberra'] },
  { code: 'AT', name: 'Austria', cities: ['Vienna', 'Graz', 'Linz', 'Salzburg'] },
  { code: 'AZ', name: 'Azerbaijan', cities: ['Baku', 'Ganja', 'Sumqayit'] },
  { code: 'BH', name: 'Bahrain', cities: ['Manama', 'Riffa', 'Muharraq'] },
  { code: 'BD', name: 'Bangladesh', cities: ['Dhaka', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet'] },
  { code: 'BY', name: 'Belarus', cities: ['Minsk', 'Gomel', 'Mogilev'] },
  { code: 'BE', name: 'Belgium', cities: ['Brussels', 'Antwerp', 'Ghent', 'Bruges'] },
  { code: 'BZ', name: 'Belize', cities: ['Belmopan', 'Belize City'] },
  { code: 'BJ', name: 'Benin', cities: ['Porto-Novo', 'Cotonou', 'Parakou'] },
  { code: 'BT', name: 'Bhutan', cities: ['Thimphu', 'Phuntsholing'] },
  { code: 'BO', name: 'Bolivia', cities: ['La Paz', 'Santa Cruz', 'Cochabamba', 'Sucre'] },
  { code: 'BA', name: 'Bosnia and Herzegovina', cities: ['Sarajevo', 'Banja Luka', 'Mostar'] },
  { code: 'BW', name: 'Botswana', cities: ['Gaborone', 'Francistown'] },
  { code: 'BR', name: 'Brazil', cities: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Belo Horizonte'] },
  { code: 'BN', name: 'Brunei', cities: ['Bandar Seri Begawan'] },
  { code: 'BG', name: 'Bulgaria', cities: ['Sofia', 'Plovdiv', 'Varna', 'Burgas'] },
  { code: 'BF', name: 'Burkina Faso', cities: ['Ouagadougou', 'Bobo-Dioulasso'] },
  { code: 'BI', name: 'Burundi', cities: ['Gitega', 'Bujumbura'] },
  { code: 'KH', name: 'Cambodia', cities: ['Phnom Penh', 'Siem Reap', 'Battambang'] },
  { code: 'CM', name: 'Cameroon', cities: ['Yaoundé', 'Douala', 'Garoua'] },
  { code: 'CA', name: 'Canada', cities: ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa', 'Edmonton'] },
  { code: 'CV', name: 'Cape Verde', cities: ['Praia', 'Mindelo'] },
  { code: 'CF', name: 'Central African Republic', cities: ['Bangui'] },
  { code: 'TD', name: 'Chad', cities: ["N'Djamena", 'Moundou'] },
  { code: 'CL', name: 'Chile', cities: ['Santiago', 'Valparaíso', 'Concepción'] },
  { code: 'CN', name: 'China', cities: ['Beijing', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Chengdu', 'Hangzhou'] },
  { code: 'CO', name: 'Colombia', cities: ['Bogotá', 'Medellín', 'Cali', 'Barranquilla'] },
  { code: 'KM', name: 'Comoros', cities: ['Moroni'] },
  { code: 'CG', name: 'Congo', cities: ['Brazzaville', 'Pointe-Noire'] },
  { code: 'CD', name: 'Congo (DRC)', cities: ['Kinshasa', 'Lubumbashi', 'Mbuji-Mayi'] },
  { code: 'CR', name: 'Costa Rica', cities: ['San José', 'Limón', 'Alajuela'] },
  { code: 'HR', name: 'Croatia', cities: ['Zagreb', 'Split', 'Rijeka', 'Dubrovnik'] },
  { code: 'CU', name: 'Cuba', cities: ['Havana', 'Santiago de Cuba'] },
  { code: 'CY', name: 'Cyprus', cities: ['Nicosia', 'Limassol', 'Larnaca'] },
  { code: 'CZ', name: 'Czech Republic', cities: ['Prague', 'Brno', 'Ostrava'] },
  { code: 'DK', name: 'Denmark', cities: ['Copenhagen', 'Aarhus', 'Odense'] },
  { code: 'DJ', name: 'Djibouti', cities: ['Djibouti City'] },
  { code: 'DO', name: 'Dominican Republic', cities: ['Santo Domingo', 'Santiago'] },
  { code: 'EC', name: 'Ecuador', cities: ['Quito', 'Guayaquil', 'Cuenca'] },
  { code: 'EG', name: 'Egypt', cities: ['Cairo', 'Alexandria', 'Giza', 'Luxor'] },
  { code: 'SV', name: 'El Salvador', cities: ['San Salvador', 'Santa Ana'] },
  { code: 'EE', name: 'Estonia', cities: ['Tallinn', 'Tartu'] },
  { code: 'SZ', name: 'Eswatini', cities: ['Mbabane', 'Manzini'] },
  { code: 'ET', name: 'Ethiopia', cities: ['Addis Ababa', 'Dire Dawa', 'Gondar'] },
  { code: 'FJ', name: 'Fiji', cities: ['Suva', 'Nadi'] },
  { code: 'FI', name: 'Finland', cities: ['Helsinki', 'Espoo', 'Tampere'] },
  { code: 'FR', name: 'France', cities: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice'] },
  { code: 'GA', name: 'Gabon', cities: ['Libreville', 'Port-Gentil'] },
  { code: 'GM', name: 'Gambia', cities: ['Banjul', 'Serekunda'] },
  { code: 'GE', name: 'Georgia', cities: ['Tbilisi', 'Batumi', 'Kutaisi'] },
  { code: 'DE', name: 'Germany', cities: ['Berlin', 'Munich', 'Hamburg', 'Frankfurt', 'Cologne'] },
  { code: 'GH', name: 'Ghana', cities: ['Accra', 'Kumasi', 'Tamale'] },
  { code: 'GR', name: 'Greece', cities: ['Athens', 'Thessaloniki', 'Patras'] },
  { code: 'GT', name: 'Guatemala', cities: ['Guatemala City', 'Quetzaltenango'] },
  { code: 'GN', name: 'Guinea', cities: ['Conakry'] },
  { code: 'GY', name: 'Guyana', cities: ['Georgetown'] },
  { code: 'HT', name: 'Haiti', cities: ['Port-au-Prince', 'Cap-Haïtien'] },
  { code: 'HN', name: 'Honduras', cities: ['Tegucigalpa', 'San Pedro Sula'] },
  { code: 'HK', name: 'Hong Kong', cities: ['Hong Kong'] },
  { code: 'HU', name: 'Hungary', cities: ['Budapest', 'Debrecen', 'Szeged'] },
  { code: 'IS', name: 'Iceland', cities: ['Reykjavík'] },
  { code: 'IN', name: 'India', cities: ['Mumbai', 'Delhi', 'Bengaluru', 'Chennai', 'Kolkata', 'Hyderabad'] },
  { code: 'ID', name: 'Indonesia', cities: ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Bali (Denpasar)'] },
  { code: 'IR', name: 'Iran', cities: ['Tehran', 'Mashhad', 'Isfahan'] },
  { code: 'IQ', name: 'Iraq', cities: ['Baghdad', 'Basra', 'Mosul'] },
  { code: 'IE', name: 'Ireland', cities: ['Dublin', 'Cork', 'Galway'] },
  { code: 'IL', name: 'Israel', cities: ['Jerusalem', 'Tel Aviv', 'Haifa'] },
  { code: 'IT', name: 'Italy', cities: ['Rome', 'Milan', 'Naples', 'Turin', 'Florence'] },
  { code: 'CI', name: "Côte d'Ivoire", cities: ['Yamoussoukro', 'Abidjan'] },
  { code: 'JM', name: 'Jamaica', cities: ['Kingston', 'Montego Bay'] },
  { code: 'JP', name: 'Japan', cities: ['Tokyo', 'Osaka', 'Yokohama', 'Nagoya', 'Kyoto'] },
  { code: 'JO', name: 'Jordan', cities: ['Amman', 'Zarqa', 'Irbid'] },
  { code: 'KZ', name: 'Kazakhstan', cities: ['Astana', 'Almaty', 'Shymkent'] },
  { code: 'KE', name: 'Kenya', cities: ['Nairobi', 'Mombasa', 'Kisumu'] },
  { code: 'KW', name: 'Kuwait', cities: ['Kuwait City'] },
  { code: 'KG', name: 'Kyrgyzstan', cities: ['Bishkek', 'Osh'] },
  { code: 'LA', name: 'Laos', cities: ['Vientiane', 'Luang Prabang'] },
  { code: 'LV', name: 'Latvia', cities: ['Riga', 'Daugavpils'] },
  { code: 'LB', name: 'Lebanon', cities: ['Beirut', 'Tripoli', 'Sidon'] },
  { code: 'LS', name: 'Lesotho', cities: ['Maseru'] },
  { code: 'LR', name: 'Liberia', cities: ['Monrovia'] },
  { code: 'LY', name: 'Libya', cities: ['Tripoli', 'Benghazi'] },
  { code: 'LT', name: 'Lithuania', cities: ['Vilnius', 'Kaunas'] },
  { code: 'LU', name: 'Luxembourg', cities: ['Luxembourg City'] },
  { code: 'MO', name: 'Macau', cities: ['Macau'] },
  { code: 'MG', name: 'Madagascar', cities: ['Antananarivo', 'Toamasina'] },
  { code: 'MW', name: 'Malawi', cities: ['Lilongwe', 'Blantyre'] },
  { code: 'MY', name: 'Malaysia', cities: ['Kuala Lumpur', 'George Town', 'Johor Bahru', 'Ipoh'] },
  { code: 'MV', name: 'Maldives', cities: ['Malé'] },
  { code: 'ML', name: 'Mali', cities: ['Bamako'] },
  { code: 'MT', name: 'Malta', cities: ['Valletta'] },
  { code: 'MR', name: 'Mauritania', cities: ['Nouakchott'] },
  { code: 'MU', name: 'Mauritius', cities: ['Port Louis'] },
  { code: 'MX', name: 'Mexico', cities: ['Mexico City', 'Guadalajara', 'Monterrey', 'Puebla'] },
  { code: 'MD', name: 'Moldova', cities: ['Chișinău'] },
  { code: 'MC', name: 'Monaco', cities: ['Monaco'] },
  { code: 'MN', name: 'Mongolia', cities: ['Ulaanbaatar'] },
  { code: 'ME', name: 'Montenegro', cities: ['Podgorica'] },
  { code: 'MA', name: 'Morocco', cities: ['Rabat', 'Casablanca', 'Marrakesh', 'Fez'] },
  { code: 'MZ', name: 'Mozambique', cities: ['Maputo', 'Beira'] },
  { code: 'MM', name: 'Myanmar', cities: ['Naypyidaw', 'Yangon', 'Mandalay'] },
  { code: 'NA', name: 'Namibia', cities: ['Windhoek'] },
  { code: 'NP', name: 'Nepal', cities: ['Kathmandu', 'Pokhara'] },
  { code: 'NL', name: 'Netherlands', cities: ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht'] },
  { code: 'NZ', name: 'New Zealand', cities: ['Auckland', 'Wellington', 'Christchurch'] },
  { code: 'NI', name: 'Nicaragua', cities: ['Managua'] },
  { code: 'NE', name: 'Niger', cities: ['Niamey'] },
  { code: 'NG', name: 'Nigeria', cities: ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Port Harcourt'] },
  { code: 'KP', name: 'North Korea', cities: ['Pyongyang'] },
  { code: 'MK', name: 'North Macedonia', cities: ['Skopje'] },
  { code: 'NO', name: 'Norway', cities: ['Oslo', 'Bergen', 'Trondheim'] },
  { code: 'OM', name: 'Oman', cities: ['Muscat', 'Salalah'] },
  { code: 'PK', name: 'Pakistan', cities: ['Karachi', 'Lahore', 'Islamabad', 'Faisalabad', 'Rawalpindi'] },
  { code: 'PA', name: 'Panama', cities: ['Panama City', 'Colón'] },
  { code: 'PG', name: 'Papua New Guinea', cities: ['Port Moresby'] },
  { code: 'PY', name: 'Paraguay', cities: ['Asunción'] },
  { code: 'PE', name: 'Peru', cities: ['Lima', 'Arequipa', 'Trujillo'] },
  { code: 'PH', name: 'Philippines', cities: ['Manila', 'Quezon City', 'Cebu City', 'Davao City'] },
  { code: 'PL', name: 'Poland', cities: ['Warsaw', 'Kraków', 'Łódź', 'Wrocław'] },
  { code: 'PT', name: 'Portugal', cities: ['Lisbon', 'Porto', 'Braga'] },
  { code: 'QA', name: 'Qatar', cities: ['Doha', 'Al Rayyan'] },
  { code: 'RO', name: 'Romania', cities: ['Bucharest', 'Cluj-Napoca', 'Timișoara'] },
  { code: 'RU', name: 'Russia', cities: ['Moscow', 'Saint Petersburg', 'Novosibirsk', 'Kazan'] },
  { code: 'RW', name: 'Rwanda', cities: ['Kigali'] },
  { code: 'SA', name: 'Saudi Arabia', cities: ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam'] },
  { code: 'SN', name: 'Senegal', cities: ['Dakar', 'Touba'] },
  { code: 'RS', name: 'Serbia', cities: ['Belgrade', 'Novi Sad', 'Niš'] },
  { code: 'SC', name: 'Seychelles', cities: ['Victoria'] },
  { code: 'SL', name: 'Sierra Leone', cities: ['Freetown'] },
  { code: 'SG', name: 'Singapore', cities: ['Singapore'] },
  { code: 'SK', name: 'Slovakia', cities: ['Bratislava', 'Košice'] },
  { code: 'SI', name: 'Slovenia', cities: ['Ljubljana', 'Maribor'] },
  { code: 'SO', name: 'Somalia', cities: ['Mogadishu'] },
  { code: 'ZA', name: 'South Africa', cities: ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria'] },
  { code: 'KR', name: 'South Korea', cities: ['Seoul', 'Busan', 'Incheon', 'Daegu'] },
  { code: 'SS', name: 'South Sudan', cities: ['Juba'] },
  { code: 'ES', name: 'Spain', cities: ['Madrid', 'Barcelona', 'Valencia', 'Seville'] },
  { code: 'LK', name: 'Sri Lanka', cities: ['Colombo', 'Kandy', 'Galle', 'Jaffna', 'Negombo', 'Kurunegala'] },
  { code: 'SD', name: 'Sudan', cities: ['Khartoum', 'Omdurman'] },
  { code: 'SR', name: 'Suriname', cities: ['Paramaribo'] },
  { code: 'SE', name: 'Sweden', cities: ['Stockholm', 'Gothenburg', 'Malmö'] },
  { code: 'CH', name: 'Switzerland', cities: ['Zurich', 'Geneva', 'Bern', 'Basel'] },
  { code: 'SY', name: 'Syria', cities: ['Damascus', 'Aleppo'] },
  { code: 'TW', name: 'Taiwan', cities: ['Taipei', 'Kaohsiung', 'Taichung'] },
  { code: 'TJ', name: 'Tajikistan', cities: ['Dushanbe'] },
  { code: 'TZ', name: 'Tanzania', cities: ['Dodoma', 'Dar es Salaam', 'Mwanza'] },
  { code: 'TH', name: 'Thailand', cities: ['Bangkok', 'Chiang Mai', 'Phuket', 'Pattaya'] },
  { code: 'TL', name: 'Timor-Leste', cities: ['Dili'] },
  { code: 'TG', name: 'Togo', cities: ['Lomé'] },
  { code: 'TT', name: 'Trinidad and Tobago', cities: ['Port of Spain', 'San Fernando'] },
  { code: 'TN', name: 'Tunisia', cities: ['Tunis', 'Sfax'] },
  { code: 'TR', name: 'Turkey', cities: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya'] },
  { code: 'TM', name: 'Turkmenistan', cities: ['Ashgabat'] },
  { code: 'UG', name: 'Uganda', cities: ['Kampala'] },
  { code: 'UA', name: 'Ukraine', cities: ['Kyiv', 'Kharkiv', 'Odesa', 'Lviv'] },
  { code: 'AE', name: 'United Arab Emirates', cities: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman'] },
  { code: 'GB', name: 'United Kingdom', cities: ['London', 'Manchester', 'Birmingham', 'Glasgow', 'Liverpool'] },
  { code: 'US', name: 'United States', cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Miami', 'San Francisco'] },
  { code: 'UY', name: 'Uruguay', cities: ['Montevideo'] },
  { code: 'UZ', name: 'Uzbekistan', cities: ['Tashkent', 'Samarkand'] },
  { code: 'VU', name: 'Vanuatu', cities: ['Port Vila'] },
  { code: 'VE', name: 'Venezuela', cities: ['Caracas', 'Maracaibo', 'Valencia'] },
  { code: 'VN', name: 'Vietnam', cities: ['Hanoi', 'Ho Chi Minh City', 'Da Nang'] },
  { code: 'YE', name: 'Yemen', cities: ["Sana'a", 'Aden'] },
  { code: 'ZM', name: 'Zambia', cities: ['Lusaka', 'Ndola'] },
  { code: 'ZW', name: 'Zimbabwe', cities: ['Harare', 'Bulawayo'] },
];

// Helper functions
export const getCountryByName = (name: string): Country | undefined => {
  return countries.find(country => country.name === name);
};

export const getCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code);
};

export const getCitiesByCountryName = (countryName: string): string[] => {
  const country = getCountryByName(countryName);
  return country ? country.cities : [];
};

export const getCitiesByCountryCode = (countryCode: string): string[] => {
  const country = getCountryByCode(countryCode);
  return country ? country.cities : [];
};
